module.exports = __webpack_public_path__ + "static/media/VectorID.ea124a9f.svg";